import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
  Tooltip,
  IconButton,
  Badge,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { peticionGet } from "./ComponenteAxios";
// Iconos
import SpaceDashboardRounded from "@mui/icons-material/SpaceDashboardRounded"; // Dashboard
import PeopleAltRounded from "@mui/icons-material/PeopleAltRounded"; // Clientes
import CategoryRounded from "@mui/icons-material/CategoryRounded"; // Productos (nuevo)
import SettingsSuggestRounded from "@mui/icons-material/SettingsSuggestRounded"; // Definiciones
import RequestQuoteRounded from "@mui/icons-material/RequestQuoteRounded"; // Ventas
import RouteIcon from "@mui/icons-material/Route";
import LogoutRounded from "@mui/icons-material/LogoutRounded"; // Logout
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"; // Submenú flecha
import Settings from "@mui/icons-material/Settings"; // Configuración
import BusinessRounded from "@mui/icons-material/BusinessRounded"; // Configuración
import GroupsIcon from "@mui/icons-material/Groups";
const BarraNavegacion = ({ titulo, onLogout }) => {
  const role = localStorage.getItem(process.env.REACT_APP_ROL_KEY);
  const nombre = localStorage.getItem(process.env.REACT_APP_NOMBRE_KEY);
  const empresa = localStorage.getItem(process.env.REACT_APP_EMPRESA_KEY);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();

  // Menús anclados
  const [anchorElDefiniciones, setAnchorElDefiniciones] = useState(null);
  const [anchorElVentas, setAnchorElVentas] = useState(null);
  const [anchorElProcesos, setAnchorElProcesos] = useState(null);
  const [anchorElCobros, setAnchorElCobros] = useState(null);

  const openDefiniciones = Boolean(anchorElDefiniciones);
  const openVentas = Boolean(anchorElVentas);
  const openProcesos = Boolean(anchorElProcesos);
  const openCobros = Boolean(anchorElCobros);

  const handleMenuClick = (setter) => (event) => setter(event.currentTarget);
  const handleMenuClose = (setter) => () => setter(null);

  const handleNavigate = (path, setter) => {
    setter(null);
    navigate(path);
  };

  const tituloNavbar = process.env.REACT_APP_TITULO_NAVBAR || "";
  const tituloNavbarMobile = process.env.REACT_APP_TITULO_NAVBAR_MOBILE || "";

  const menuItemsDefiniciones = [
    { label: "Clientes", path: "/Clientes" },
    { label: "Productos", path: "/Productos" },
    { label: "Tarifas", path: "/Tarifas" },
    // { label: "Formas De Pago", path: "/FormasDePago" },
    // { label: "Marcas", path: "/Marcas" },
    // { label: "Proveedores", path: "/Proveedores" },
    // { label: "Series", path: "/Series" },
    // { label: "Tipos De Cliente", path: "/TiposDeCliente" },
    // { label: "Tipos De Iva", path: "/TiposDeIva" },
    // { label: "Zonas", path: "/Zonas" },
  ];

  const menuItemsVentas = [
    { label: "Nuevo Pedido", path: "/Pedidos/Nuevo" },
    { label: "Ver Pedidos", path: "/Pedidos" },
    // { label: "Albaranes", path: "/Albaranes" },
    // { label: "Borradores Factura", path: "/BorradoresFacturas" },
    // { label: "Facturas", path: "/Facturas" },
  ];
  const menuItemsCobros = [];

  return (
    <AppBar position="static">
      <Toolbar>
        <img
          src={process.env.REACT_APP_LOGO_NAVBAR}
          alt="Logo"
          style={{ height: 40, marginRight: 16, cursor: "pointer" }}
          onClick={() => navigate("/")}
        />

        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            cursor: "pointer",
            "&:hover": { textDecoration: "none", color: "inherit" },
          }}
          onClick={() => navigate("/")}
        >
          {isMobile ? tituloNavbarMobile : tituloNavbar}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            // cursor: "pointer",
            // "&:hover": { textDecoration: "none", color: "inherit" },
          }}
          // onClick={() => navigate("/")}
        >
          {nombre} | {empresa}
        </Typography>
        {role === "Super Admin" ? (
          /* tu <NavLink to="/Tarifas" /> o el item que corresponda */
          <>
            <Tooltip title="Usuarios">
              <IconButton
                color="inherit"
                aria-label="Ir a Usuarios"
                onClick={() => navigate("/Usuarios")}
                size={isMobile ? "small" : "medium"}
                sx={{ mr: 1 }}
              >
                <PeopleAltRounded />
              </IconButton>
            </Tooltip>
            <Tooltip title="Empresas">
              <IconButton
                color="inherit"
                aria-label="Ir a Empresas"
                onClick={() => navigate("/Empresas")}
                size={isMobile ? "small" : "medium"}
                sx={{ mr: 1 }}
              >
                <BusinessRounded />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            {/* Dashboard */}
            <Tooltip title="Dashboard">
              <IconButton
                color="inherit"
                aria-label="Ir al Dashboard"
                onClick={() => navigate("/")}
                sx={{ mr: 1 }}
              >
                <SpaceDashboardRounded />
              </IconButton>
            </Tooltip>
            {role === "Administrador" ? (
              /* tu <NavLink to="/Tarifas" /> o el item que corresponda */
              <>
                <Tooltip title="Comerciales">
                  <IconButton
                    color="inherit"
                    aria-label="Ir a Comerciales"
                    onClick={() => navigate("/Comerciales")}
                    size={isMobile ? "small" : "medium"}
                    sx={{ mr: 1 }}
                  >
                    <GroupsIcon />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <></>
            )}
            <Tooltip title="Rutas">
              <IconButton
                color="inherit"
                aria-label="Ir a Rutas"
                onClick={() => navigate("/Agenda")}
                size={isMobile ? "small" : "medium"}
                sx={{ mr: 1 }}
              >
                <RouteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Clientes">
              <IconButton
                color="inherit"
                aria-label="Ir a Clientes"
                onClick={() => navigate("/Clientes")}
                size={isMobile ? "small" : "medium"}
                sx={{ mr: 1 }}
              >
                <PeopleAltRounded />
              </IconButton>
            </Tooltip>

            {/* Productos (nuevo icono) */}
            <Tooltip title="Productos">
              <IconButton
                color="inherit"
                aria-label="Ir a Productos"
                onClick={() => navigate("/Productos")}
                size={isMobile ? "small" : "medium"}
                sx={{ mr: 2 }}
              >
                <CategoryRounded />
              </IconButton>
            </Tooltip>

            {/* Definiciones */}
            <Tooltip title="Definiciones">
              <Button
                color="inherit"
                startIcon={<SettingsSuggestRounded />}
                onClick={handleMenuClick(setAnchorElDefiniciones)}
                aria-label="Abrir menú Definiciones"
                sx={{ mr: 1 }}
              >
                Definiciones
              </Button>
            </Tooltip>
            <Menu
              anchorEl={anchorElDefiniciones}
              open={openDefiniciones}
              onClose={handleMenuClose(setAnchorElDefiniciones)}
            >
              {menuItemsDefiniciones.map(({ label, path }) => (
                <MenuItem
                  key={path}
                  onClick={() => handleNavigate(path, setAnchorElDefiniciones)}
                >
                  {label}
                </MenuItem>
              ))}
            </Menu>

            {/* Ventas */}
            <Button
              color="inherit"
              startIcon={<RequestQuoteRounded />}
              onClick={handleMenuClick(setAnchorElVentas)}
              sx={{ mr: 1 }}
            >
              Ventas
            </Button>

            <Menu
              anchorEl={anchorElVentas}
              open={openVentas}
              onClose={() => {
                setAnchorElProcesos(null);
                setAnchorElVentas(null);
              }}
            >
              {menuItemsVentas.map(({ label, path }) => (
                <MenuItem
                  key={path}
                  onClick={() => handleNavigate(path, setAnchorElVentas)}
                >
                  {label}
                </MenuItem>
              ))}

              {/* Submenú Procesos dentro de Ventas */}

              {/* <MenuItem
                onMouseEnter={(e) => setAnchorElProcesos(e.currentTarget)}
                onClick={(e) => setAnchorElProcesos(e.currentTarget)}
              >
                Procesos
                <KeyboardArrowRight
                  fontSize="small"
                  style={{ marginLeft: "auto" }}
                />
              </MenuItem>
              <Menu
                anchorEl={anchorElProcesos}
                open={openProcesos}
                onClose={() => setAnchorElProcesos(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                MenuListProps={{
                  onMouseLeave: () => setAnchorElProcesos(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setAnchorElProcesos(null);
                    setAnchorElVentas(null);
                    navigate("/FacturacionAlbaranes");
                  }}
                >
                  Facturación Albaranes
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorElProcesos(null);
                    setAnchorElVentas(null);
                    navigate("/FacturacionCuotas");
                  }}
                >
                  Facturación Cuotas
                </MenuItem>
              </Menu> */}
            </Menu>

            {/* Cobros */}

            <Button
              color="inherit"
              startIcon={<RequestQuoteRounded />}
              onClick={handleMenuClick(setAnchorElCobros)}
              sx={{ mr: 1 }}
            >
              Cobros
            </Button>
            <Menu
              anchorEl={anchorElCobros}
              open={openCobros}
              onClose={() => {
                setAnchorElProcesos(null);
                setAnchorElVentas(null);
                setAnchorElCobros(null);
              }}
            >
              {menuItemsCobros.map(({ label, path }) => (
                <MenuItem
                  key={path}
                  onClick={() => handleNavigate(path, setAnchorElCobros)}
                >
                  {label}
                </MenuItem>
              ))}
            </Menu>

            {/* <Button
              color="inherit"
              startIcon={<PaymentsRounded />}
              onClick={handleMenuClick(setAnchorElCobros)}
              sx={{ mr: 1 }}
            >
              Cobros
            </Button>
            <Menu
              anchorEl={anchorElCobros}
              open={openCobros}
              onClose={handleMenuClose(setAnchorElCobros)}
            >
              <MenuItem
                onClick={() =>
                  handleNavigate("/RecibosVenta", setAnchorElCobros)
                }
              >
                Recibos
              </MenuItem>
              <MenuItem
                onClick={() => handleNavigate("/Remesas", setAnchorElCobros)}
              >
                Remesas
              </MenuItem>
            </Menu> */}
          </>
        )}

        {/* <Tooltip title="VERI*FACTU">
          <IconButton
            color="inherit"
            aria-label="VERI*FACTU"
            onClick={() => navigate("/Verifactu")}
            sx={{ fontSize: 668, mr: 1 }}
          >
            <VeriFactuIcon />
          </IconButton>
        </Tooltip> */}
        {/* Clientes */}

        {/* Logout */}
        <Button
          color="inherit"
          startIcon={<LogoutRounded />}
          onClick={onLogout}
          aria-label="Cerrar sesión"
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default BarraNavegacion;
